import React, { Component } from 'react';

import './TemplateFooter.css'

import FacebookLogo from './FacebookLogo';
import InstagramLogo from './InstagramLogo';
import LinkedInLogo from './LinkedInLogo';
import YouTubeLogo from './YouTubeLogo';
import PinterestLogo from './PinterestLogo';
import TwitterLogo from './TwitterLogo';
import SnapchatLogo from './SnapchatLogo';

/**
 * This is a static react port of the cdc template footer
 * for template package 4.5
 */
export default class TemplateFooter extends Component {

  render() {
    return (
      <footer className="" role="contentinfo" aria-label="Footer">
        <div className="container-fluid footer-wrapper">
          <div className="container">
            <div className="footer-2022">
              <div className="footer-desktop">
                <div className="row">
                  <div className="col-xs-12 col-md-6 about">
                    <ul className="d-flex flex-xs-column justify-content-center justify-content-md-start">
                      <li><a href="https://www.cdc.gov/about/default.htm">About CDC</a></li>
                      <li><a href="https://www.cdc.gov/cdc-info/index.html">Contact Us</a></li>
                      <li><a href="tel:8002324636">800-232-4636</a></li>
                    </ul>
                  </div>
                  <div className="col-xs-12 col-md-6 social">
                    <div className="d-flex flex-wrap justify-content-center
                              justify-content-md-end justify-content-sm-around">
                      <a href="https://www.facebook.com/CDC" target="_blank"
                        rel="noreferrer noopener">
                        <div className="circle">
                          <FacebookLogo alt="Facebook" />
                        </div>
                        <span className="visually-hidden">Facebook</span></a>
                      <a href="https://twitter.com/CDCgov" target="_blank" rel="noreferrer noopener">
                        <div className="circle">
                          <TwitterLogo alt="Twitter" />
                        </div>
                        <span className="visually-hidden">Twitter</span></a>
                      <a href="https://www.instagram.com/CDCgov/" target="_blank"
                        rel="noreferrer noopener">
                        <div className="circle">
                          <InstagramLogo alt="Instagram" />
                        </div>
                        <span
                          className="visually-hidden">Instagram</span></a>
                      <a href="https://www.linkedin.com/company/centers-for-disease-control-and-prevention"
                        target="_blank" rel="noreferrer noopener">
                        <div className="circle">
                          <LinkedInLogo alt="LinkedIn" />
                        </div>
                        <span
                          className="visually-hidden">LinkedIn</span></a>
                      <a href="https://www.youtube.com/c/cdc/" target="_blank"
                        rel="noreferrer noopener">
                        <div className="circle">
                          <YouTubeLogo alt="YouTube" />
                        </div>  <span
                          className="visually-hidden">Youtube</span></a>
                      <a href="https://www.pinterest.com/cdcgov/" target="_blank"
                        rel="noreferrer noopener">
                        <div className="circle">
                          <PinterestLogo alt="Pinterest" />
                        </div>
                        <span
                          className="visually-hidden">Pinterest</span></a>
                      <a href="https://www.snapchat.com/add/cdcgov" target="_blank"
                        rel="noreferrer noopener">
                        <div className="circle">
                          <SnapchatLogo alt="Snapchat" />
                        </div> <span
                          className="visually-hidden">Snapchat</span></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid agency-footer">
          <div className="container">
            <div className="footer-2022 footer-agency row">
              <div className="col">
                <ul>
                  <li><a href="https://www.hhs.gov/">U.S. Department of Health &amp; Human Services</a></li>
                  <li className="d-none d-md-block"><a
                    href="https://www.cdc.gov/other/accessibility.html">Accessibility</a></li>
                  <li className="d-none d-md-block"><a href="https://www.cdc.gov/Other/disclaimer.html">External
                    Links</a></li>
                  <li className="d-none d-md-block"><a href="https://www.cdc.gov/other/privacy.html">Privacy</a>
                  </li>
                  <li className="d-none d-md-block"><a href="https://www.cdc.gov/Other/policies.html">Policies</a>
                  </li>
                  <li className="d-none d-md-block"><a href="https://www.cdc.gov/oeeowe/nofearact/">No Fear
                    Act</a></li>
                  <li className="d-none d-md-block"><a href="https://www.cdc.gov/od/foia">FOIA</a></li>
                  <li className="d-none d-md-block"><a
                    href="https://www.cdc.gov/other/nondiscrimination.html">Nondiscrimination</a></li>
                  <li className="d-none d-md-block"><a href="https://oig.hhs.gov">OIG</a></li>
                  <li className="d-none d-md-block"><a
                    href="https://www.hhs.gov/vulnerability-disclosure-policy/index.html">Vulnerability
                    Disclosure Policy</a></li>
                  <li><a href="https://www.usa.gov/">USA.gov</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
